import React from "react";

import { generatePath, Navigate as RouterNavigate } from "react-router";

import { Link as DSLink, LinkProps } from "ds/Button";

import type {
  AllRoutes,
  ExtractParams,
  GeneratePathParams
} from "./getConsoleURL";

type LinkParams<Path extends AllRoutes> =
  ExtractParams<Path> extends never
    ? { to: Path; params?: ExtractParams<Path> }
    : { to: Path; params: ExtractParams<Path> };

type Props<Path extends AllRoutes> = LinkProps & LinkParams<Path>;

export const Link = <Path extends AllRoutes>(props: Props<Path>) => (
  <DSLink {...props} />
);

/**
 * <Navigate to="/-/users/:username" params={{ username: "test" }} />
 * <Navigate to="/users/" />
 */
export const Navigate = <Path extends AllRoutes>(props: LinkParams<Path>) => (
  <RouterNavigate
    to={generatePath(props.to, props.params as GeneratePathParams<Path>)}
  />
);
